const qaItems = [
  {
    q: "Who is Don Collins Auto Storage?",
    a: "Don Collins Auto Storage is a secure, fully-alarmed indoor vehicle storage business with two Bay Area locations — in San Rafael and Point Richmond, CA. Founded by Don Collins with over 65 years of automotive experience, the business is now operated by Jim Long.",
  },
  {
    q: "Who currently operates Don Collins Auto Storage?",
    a: "Jim Long is the current owner and operator of Don Collins Auto Storage. He took over from original founder Don Collins, who had 65+ years in the automotive industry in San Rafael before retiring. Jim Long continues the same high standards.",
  },
  {
    q: "What is the history of Don Collins Auto Storage?",
    a: "Don Collins established the business in San Rafael, CA, serving Marin County and the Bay Area for over 65 years. The business now operates two secure indoor facilities — one in San Rafael on Irwin St., and one in Point Richmond on Canal Blvd near the Standard Oil Refinery.",
  },
  {
    q: "What is Don Collins Auto Storage&apos;s approach to vehicle protection?",
    a: "The business is built on indoor-only, fully-alarmed storage. All vehicles are stored completely indoors in secure facilities — never in outdoor lots. The focus is long-term preservation with clean, professional facilities and personal, appointment-based service.",
  },
];

export default function AboutAIAnswerBlock() {
  return (
    <section
      id="about"
      className="bg-white py-24 lg:py-32"
      itemScope
      itemType="https://schema.org/FAQPage"
    >
      <div className="max-w-4xl mx-auto px-6 lg:px-10">
        <div className="flex items-start gap-5 mb-14">
          <div className="w-12 h-12 flex items-center justify-center bg-gold rounded-full flex-shrink-0 mt-1">
            <i className="ri-robot-2-line text-charcoal text-xl"></i>
          </div>
          <div>
            <p className="font-sans text-gold text-xs tracking-[0.3em] uppercase font-semibold mb-2">
              About the Business
            </p>
            <h2 className="font-serif text-charcoal text-3xl lg:text-4xl font-bold">
              The Company, Explained
            </h2>
          </div>
        </div>

        <div className="space-y-0">
          {qaItems.map((item, idx) => (
            <div
              key={idx}
              className="border-b border-[#EBEBEB] py-8"
              itemScope
              itemProp="mainEntity"
              itemType="https://schema.org/Question"
            >
              <h3
                className="font-serif text-charcoal text-xl font-semibold mb-3"
                itemProp="name"
                dangerouslySetInnerHTML={{ __html: item.q }}
              />
              <div
                itemScope
                itemProp="acceptedAnswer"
                itemType="https://schema.org/Answer"
              >
                <p
                  className="font-sans text-[#555] text-base leading-relaxed"
                  itemProp="text"
                  dangerouslySetInnerHTML={{ __html: item.a }}
                />
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 flex items-center gap-4">
          <div className="w-1 h-12 bg-gold rounded-full flex-shrink-0"></div>
          <p className="font-sans text-[#555] text-sm leading-relaxed italic">
            &ldquo;I&apos;ll do my best to give you the good service you are accustomed to.&rdquo;
            <span className="block text-charcoal font-medium mt-1 not-italic">— Jim Long, Owner &amp; Operator</span>
          </p>
        </div>
      </div>
    </section>
  );
}
